import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import {
  setThefinanceDataActions,
  setThefinanceDataExportActions,
  setGeoLoactionStateAction,
  setZoneActions,
  getSideBarfilesActions ,
  setRegionActions,
} from "../../../Redux/Slice";
import ReactTable from "../../AppComponent/Table";
import profile2 from "../../../Assets/AppComponent/Profile/profile2.png";
import GetAppIcon from "@material-ui/icons/GetApp";
import { toast } from "react-toastify";
import aadhar from "../../../Assets/AppComponent/Logo/aadharimage.png";
import whats from "../../../Assets/AppComponent/Logo/whatsapp.webp";
import bank from "../../../Assets/AppComponent/Logo/bank.png";
import pancard from "../../../Assets/AppComponent/Logo/pancard.png";
import { useNavigate } from "react-router-dom";
import Select from "react-select";

const Finance = () => {
  const dispatch = useDispatch();
  const stateDisplay = useSelector(
    (state) => state.SideBarActive.SidebarActive
  );
  const navigate = useNavigate();
  const [dtpageindex, setdtPageindex] = useState(1);
  const [dtpagesize, setdtPagesize] = useState(10);
  const [pageSize, setPageSize] = useState(20);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setsearch] = useState("");
  const state = useSelector((state) => state);
  const [multiselect, setMuliselect] = useState([{ value: "", label: "ALL" }]);
  let [nameList, setOptions] = useState([]);
  const [nameList2, setOptions2] = useState([]);
  const [REgion, setRegion] = useState([]);
  const [multiselect1, setMuliselect1] = useState([
    { value: "", label: "ALL" },
  ]);
  const [multiselect3, setMuliselect3] = useState([
    { value: "", label: "ALL" },
  ]);
  const [nameList4, setOptions4] = useState([]);
  const [Zone, setZone] = useState([]);
  const [data, setData] = useState({ zone: "", state: "", region: "" });
  const initialStateSearch = {
    stateSearch: "",
    regionSearch: "",
    zoneSearch: "",
  };
  const [SearchedVal, setSearched] = useState(initialStateSearch);
  const [Perecentagedata, setPercentageData] = useState({
    ///---counts  fro the  employees
    aadhar_count: 4,
    bank_count: 2,
    pan_count: 4,
    whats_app_amount: 2,
  });

  ///-----State----Input Changes
  const handleInputChange = (Val) => {
    console.log(Val, "Values");
    setSearched({
      ...SearchedVal,
      stateSearch: Val,
    });
  };

  ///---Region-----------------
  const handleInputRegion = (Val) => {
    setSearched({
      ...SearchedVal,
      regionSearch: Val,
    });
  };
  ///----Zone---Name
  const handleInputZone = (Val) => {
    setSearched({
      ...SearchedVal,
      zoneSearch: Val,
    });
  };

  var today = new Date();
  var priorDate = new Date(new Date().setDate(today.getDate() - 30));
  var it = convert(today);
  var gt = convert(priorDate);
  // console.log(it, gt);
  const [range, setrange] = useState([gt, it]);

  function convert(str) {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  }

  //----Handle----Date=-----Changes---
  const handlechangedate = (value) => {
    if (value != null) {
      setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
    }
  };

  const cleaningrange = () => {
    //setrange([gt,it]);
  };

  const pagesize = (arg) => {
    setdtPagesize(arg);
  };
  const pageindex = (arg) => {
    //  console.log(arg, "args");
    setdtPageindex(arg);
  };

  const predefinedBottomRanges = [
    {
      label: "Today",
      value: [new Date(), new Date()],
      placement: "left",
    },
    {
      label: "Yesterday",
      value: [addDays(new Date(), -1), addDays(new Date(), -1)],
      placement: "left",
    },
    {
      label: "This week",
      value: [startOfWeek(new Date()), endOfWeek(new Date())],
      placement: "left",
    },
    {
      label: "Last week",
      value: (value, index) => {
        const [start = new Date()] = value[index] || [];
        return [
          addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
          addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
        ];
      },
      placement: "left",
    },
    {
      label: "Last 30 days",
      value: [subDays(new Date(), 29), new Date()],
      placement: "left",
    },
  ];

  function tochange(e) {
    setsearch(e);
    setdtPageindex(1);
    if (e.trim() != undefined && e.trim() != "") {
      const payload = {
        search: e.trim(),
        page_size: 10,
        page: 1,
        return_type: "normal",
        from_date: range[0],
        to_data: range[1],
        state: data.state,
        region: data.region,
        zone: data.zone,
      };

      dispatch(setThefinanceDataActions(payload));
    }
    if (e == "" || search == "") {
      const payload = {
        search: "",
        page_size: 10,
        page: 1,
        return_type: "normal",
        from_date: range[0],
        to_data: range[1],
        state: data.state,
        region: data.region,
        zone: data.zone,
      };
      dispatch(setThefinanceDataActions(payload));
    }
  }

  ///--------------State-----------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.stateSearch,
      page_size: "",
      page: 1,
    };
    dispatch(setGeoLoactionStateAction(payloads));
  }, [SearchedVal.stateSearch]);
  //--------------_Zone---------------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.zoneSearch,
      page_size: 20,
      page: 1,
      counts: 1,
      region_id: data.region,
    };
    dispatch(setZoneActions(payloads));
    setZone(state.ZonePart.Zone);
  }, [data.region, SearchedVal.zoneSearch]);

  //-----Region---------
  useEffect(() => {
    const payloads = {
      search: SearchedVal.regionSearch,
      page_size: 20,
      page: 1,
      counts: 1, //-----only we ----get----the----selected regions , the--id only
      state: data.state,
    };
    dispatch(setRegionActions(payloads));
    //console.log(State.regioncall.RegionDat, "states", State.regioncall.Total_Count);
    setRegion(state.regioncall.RegionDat);
  }, [data.state, SearchedVal.regionSearch]);

  const handleSelectChange = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect(selectedVal);
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...data,
        state: selectedVal.value,
        region: "",
        zone: "",
      });
    }
    if (selectedVal == null) {
      setMuliselect({ value: "", label: "ALL" });
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...data,
        state: "",
        region: "",
        zone: "",
      });
    }
  };

  useEffect(() => {
    if (state.FinanceGetListedData.FinanceDatasCounts) {
      const optionsDatas = {
        aadhar_count:
          state.FinanceGetListedData.FinanceDatasCounts.aadhar_count,
        bank_count: state.FinanceGetListedData.FinanceDatasCounts.bank_count,
        pan_count: state.FinanceGetListedData.FinanceDatasCounts.pan_count,

        whats_app_amount:
          state.FinanceGetListedData.FinanceDatasCounts.whats_app_amount,
      };

      setPercentageData(optionsDatas);
    }
  }, [state.FinanceGetListedData.FinanceDatasCounts]);
  useEffect(() => {
    if (state.GeoState.State != undefined) {
      let objectArray = [];
      setOptions({ value: "", label: "ALL" });

      state.GeoState.State.forEach((element) => {
        objectArray.push({ value: element.id, label: element.state_name.toUpperCase() });
      });

      setOptions(objectArray);
    }
  }, [state.GeoState.State, SearchedVal.stateSearch]);
  ///  ///----------------------REgion-----------
  useEffect(() => {
    const Datas = [];

    setRegion(state.regioncall.RegionDat);
    if (state.regioncall.RegionDat != undefined) {
      let objectArray = [];
      setOptions2({ value: "", label: "ALL" });

      state.regioncall.RegionDat.forEach((element) => {
        objectArray.push({ value: element.id, label: element.region_name.toUpperCase() });
      });

      setOptions2(objectArray);
    }
  }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);
  //----Region----------------
  const handelRegionSlect = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect1(selectedVal);
      setData({
        ...data,
        region: selectedVal.value,
      });
    }
    if (selectedVal == null && data.state == null && data.zone == null) {
      setData({
        ...data,
        region: "",
      });
      const payload = {
        search: "",
        page_size: dtpagesize,
        page: dtpageindex,
      };
    }
    if (selectedVal == null) {
      setMuliselect1({ value: "", label: "ALL" });
      setMuliselect3({ value: "", label: "ALL" });
      setData({
        ...data,
        region: "",
        zone: "",
      });
    }
  };
  //----------------Zone
  const handleZone = (selectedVal) => {
    if (selectedVal != null) {
      setMuliselect3(selectedVal);
      setData({
        ...data,
        zone: selectedVal.value,
      });
    }
    if (selectedVal == null && data.region == null && data.state == null) {
      setData({
        ...data,
        zone: "",
      });
      setMuliselect3({ value: "", label: "ALL" });

    }
  };
  ///-------------Zone--------------
  useEffect(() => {
    const Datas = [];

    setOptions4({ value: "", label: "ALL" });
    if (state.ZonePart.Zone != undefined) {
      let objectArray = [];
      state.ZonePart.Zone.forEach((element) => {
        objectArray.push({ value: element.id, label: element.zone_name.toUpperCase() });
      });
      setOptions4(objectArray);
    }
  }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);

  useEffect(() => {
    const payload = {
      search: search,
      page_size: 10,
      page: dtpageindex,
      return_type: "normal",
      from_date: range[0],
      to_date: range[1],
      range: true,
      state: data.state,
      region: data.region,
      zone: data.zone,
      export_type: "all",
    };
    dispatch(setThefinanceDataActions(payload));
  }, [dtpageindex, data, range]);
  const handleNext = (next) => {    
    setdtPageindex(next + 1);
};

const GotoEnteredPage =(gotopage)=>{
 setdtPageindex(gotopage)
}

const handlePrevious = (previous) => {
if (previous != 0) {
  setdtPageindex(previous);

}
};


  const columns = [
    {
      Header: "Tnx Id",
      accessor: "",
      Cell: ({ row }) => row.index + 1, // Section number based on row index
    },
    // {
    //   Header: "ID",
    //   accessor: "",

    //   Cell: (row) => {
    //     return (
    //       <>
    //         <p
    //           data-tooltip-id="my-tooltip"
    //           data-tooltip-content={row.row.original.id.slice(-12)}
    //         >
    //           {String(row.row.original.id).slice(-12)}
    //         </p>
    //       </>
    //     );
    //   },
    // },

    {
      Header: "Employee Name",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            <div className="UserName" style={{ cursor: "pointer" }}>
              <div className="">
                <span>{row.row.original.user_id.first_name}</span>
              </div>
            </div>
          </>
        );
      },
    },

    {
      Header: " NAME AS PER BANK ",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.account_holder_name != null &&
            row.row.original.account_holder_name != undefined &&
            row.row.original.account_holder_name != undefined ? (
              <div className="UserName">
                <span>{row.row.original.account_holder_name}</span>
              </div>
            ) : (
              <div className="UserName">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },

    {
      Header: "BANK NAME",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.bank_name != null &&
            row.row.original.bank_name != undefined &&
            row.row.original.bank_name != undefined ? (
              <div className="UserName">
                <span>{row.row.original.bank_name}</span>
              </div>
            ) : (
              <div className="UserName">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },

    {
      Header: "IFSC CODE",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.ifsc_code != null &&
            row.row.original.ifsc_code != undefined &&
            row.row.original.ifsc_code != undefined ? (
              <div className="UserName">
                <span>{row.row.original.ifsc_code}</span>
              </div>
            ) : (
              <div className="UserName">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },

    {
      Header: "TRANSACTION ID ",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.bank_transaction_id != null &&
            row.row.original.bank_transaction_id != undefined &&
            row.row.original.bank_transaction_id != undefined ? (
              <div className="UserName">
                <span>{row.row.original.bank_transaction_id}</span>
              </div>
            ) : (
              <div className="UserName">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },

    {
      Header: "ACCOUNT EXIST ",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.account_exists != null &&
            row.row.original.account_exists != undefined &&
            row.row.original.account_exists != undefined ? (
              <div className="UserName">
                <span>
                  {row.row.original.account_exists ? "TRUE" : "FALSE"}
                </span>
              </div>
            ) : (
              <div className="UserName">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },
    {
      Header: "AMOUNT",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.bank_send_amount != null &&
            row.row.original.bank_send_amount != undefined &&
            row.row.original.bank_send_amount != undefined ? (
              <div className="UserName">
                <span>{row.row.original.bank_send_amount}</span>
              </div>
            ) : (
              <div className="UserName">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },

    {
      Header: "AADHAAR NUMBER ",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.aadhar_number != null &&
            row.row.original.aadhar_number != undefined &&
            row.row.original.aadhar_number != undefined ? (
              <div className="UserName">
                <span>{row.row.original.aadhar_number}</span>
              </div>
            ) : (
              <div className="UserName">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },

    {
      Header: "UIDAI VERIFIED",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.account_exists != null &&
            row.row.original.account_exists != undefined &&
            row.row.original.account_exists != undefined ? (
              <div className="UserName">
                <span>
                  {row.row.original.account_exists ? "TRUE" : "FALSE"}
                </span>
              </div>
            ) : (
              <div className="UserName">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },

    {
      Header: "AADHAAR AMOUNT",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.aadhar_send_amount != null &&
            row.row.original.aadhar_send_amount != undefined &&
            row.row.original.aadhar_send_amount != undefined ? (
              <div className="UserName">
                <span>{row.row.original.aadhar_send_amount}</span>
              </div>
            ) : (
              <div className="UserName">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },

    {
      Header: " PAN CARD NUMBER",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.pan_number != null &&
            row.row.original.pan_number != undefined &&
            row.row.original.pan_number != undefined ? (
              <div className="UserName">
                <span>{row.row.original.pan_number}</span>
              </div>
            ) : (
              <div className="UserName">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },

    {
      Header: "PAN VERIFIED",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.pan_verified != null &&
            row.row.original.pan_verified != undefined &&
            row.row.original.pan_verified != undefined ? (
              <div className="UserName">
                <span>{row.row.original.pan_verified ? "TRUE" : "FALSE"}</span>
              </div>
            ) : (
              <div className="UserName">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },

    {
      Header: "PAN AMOUNT",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.pan_send_amount != null &&
            row.row.original.pan_send_amount != undefined &&
            row.row.original.pan_send_amount != undefined ? (
              <div className="UserName">
                <span>{row.row.original.pan_send_amount}</span>
              </div>
            ) : (
              <div className="UserName">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },

    {
      Header: "WHATS APP VERFIED",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.whats_app != null &&
            row.row.original.whats_app != undefined &&
            row.row.original.whats_app != undefined ? (
              <div className="UserName">
                <span>{row.row.original.whats_app ? "TRUE" : "FALSE"}</span>
              </div>
            ) : (
              <div className="UserName">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },

    {
      Header: "WHATS APP AMOUNT",
      accessor: "",
      Cell: (row) => {
        return (
          <>
            {row.row.original.whats_app_amount != null &&
            row.row.original.whats_app_amount != undefined &&
            row.row.original.whats_app_amount != undefined ? (
              <div className="UserName">
                <span>{row.row.original.whats_app_amount}</span>
              </div>
            ) : (
              <div className="UserName">
                <span>---</span>
              </div>
            )}
          </>
        );
      },
    },
  ];
  return (
    <>
      <div className={stateDisplay ? "outterContent" : "inner-Content"}>
        <div
          className="Header-Details ClientBranch row"
          style={{ padding: "14px 28px" }}
        >
          <div
            class="col-sm-7 auto"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              justifyContent: "flex-start",
            }}
          >
            <h2>Validations Overview</h2>
            {/* <ul class="breadcrumb">
              <li class="breadcrumb-item">Validations Overview</li>
            </ul> */}
          </div>
        </div>

        <div
          className="row Filters"
          style={{
            padding: "15px 28px",
            margin: "0px",
            position: "relative",
            zIndex: "30",
               

            marginLeft: "0px",
            marginRight: "0px",
            top: "-30px",
          }}
        >
          <div className="col-3">
            <label for="validationCustom01" class="form-label">
              State Name
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onSelect={(e) => {
                setMuliselect(e);
              }}
              onChange={(e) => {
                setdtPageindex(1);
                handleSelectChange(e);
              }}
              options={nameList}
              onInputChange={handleInputChange}
              onremoved={(e) => {
                setMuliselect(e);
                console.log(e, "jjk9090");
              }}
              labelledBy="Select"
              value={multiselect}
            />
          </div>

          <div className="col-3">
            <label for="validationCustom01" class="form-label">
              Region Name
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onSelect={(e) => setMuliselect1(e)}
              onChange={(e) => {
                setdtPageindex(1);

                handelRegionSlect(e);
              }}
              options={nameList2}
              labelledBy="Select"
              isClearable={true}
              onremoved={(e) => {
                setMuliselect1(e);
              }}
              value={multiselect1}
              onInputChange={handleInputRegion}
            />
          </div>

          <div className="col-3">
            <label for="validationCustom01" class="form-label">
              Zone Name
            </label>
            <Select
              className="Selects"
              styles={{ position: "relative", top: "60px" }}
              onSelect={(e) => setMuliselect3(e)}
              onChange={(e) => {
                setdtPageindex(1);
                handleZone(e);
              }}
              options={nameList4}
              isClearable={true}
              value={multiselect3}
              onremoved={(e) => {
                setMuliselect3(e);
              }}
              labelledBy="Select"
              onInputChange={handleInputZone}
            />
          </div>

          <div className="col-3">
            <label
              for="validationCustom01"
              class="form-label"
              style={{ marginBottom: "11px" }}
            ></label>

            <div className="datepicker_dash" style={{ marginTop: "-5px" }}>
              <DateRangePicker
                defaultValue={[
                  new Date(new Date().setDate(today.getDate() - 30)),
                  new Date(),
                ]}
                disabledDate={(date) => isAfter(date, new Date())}
                editable={false}
                appearance="default"
                placement="bottomEnd"
                size="lg"
                ranges={predefinedBottomRanges}
                placeholder="From - To"
                style={{ width: 300, padding: 10 }}
                onClean={(e) => cleaningrange(e)}
                onChange={(e) => {
                  if (e != null) {
                    setrange([]);
                    e.forEach((newValue) => {
                      var tzoffset = new Date().getTimezoneOffset() * 60000;
                      var localISOTime = new Date(newValue - tzoffset)
                        .toISOString()
                        .slice(0, -1);
                      //   setdtPageindex(1);
                      handlechangedate(localISOTime);
                    });
                  }
                }}
              />
            </div>
          </div>
        </div>

        <div className="row DashRows">
          <div className="col-12 mt-2">
            <h5>Validations Overview Details</h5>
          </div>
          <div className="col-xl-4 col-sm-6 col-12">
            <div className="card">
              <div
                className="card-Body"
                style={{ padding: "8px" }}
                onClick={(e) => {
                  dispatch(getSideBarfilesActions("Aadhar Details"))

                  navigate("/aadharvalidate");
                }}
              >
                <div className="Dash">
                  <div
                    className=" iconsEmpVer"
                    style={{
                      width: "68px",
                      height: "70px",
                    }}
                  >
                    {/* <i class="fa-solid fa-users-gear"></i> */}
                    <img
                      src={aadhar}
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: "18px",
                      }}
                    />
                  </div>
                  <div className="Counts" style={{ fontSize: "30px" }}>
                    {Perecentagedata.aadhar_count}
                  </div>
                </div>
                <div class="Dash-info">
                  <h6 class="text-muted">Aadhar </h6>
                  <div class="progress progress-sm">
                    <div
                      class="progress-bar bg-secondary"
                      role="progressbar"
                      style={{
                        width: `${Perecentagedata.aadhar_count / 10}%`,
                      }}
                      aria-valuenow={Perecentagedata.aadhar_count}
                      aria-valuemin="0"
                      aria-valuemax="100%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* -------------------- */}
          <div className="col-xl-4 col-sm-6 col-12">
            <div className="card">
              <div
                className="card-Body"
                style={{ padding: "8px" }}
                onClick={(e) => {
                  dispatch(getSideBarfilesActions("WhatsApp Details"))

                  navigate("/whatsappvalidate");


                }}
              >
                <div className="Dash">
                  <div
                    className=" iconsEmp"
                    style={{ width: "68px", height: "70px" }}
                  >
                    {/* <i class="fa-solid fa-user-shield"></i> */}
                    <img
                      src={whats}
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>
                  <div className="Counts" style={{ fontSize: "30px" }}>
                    {/* {state.DashboardCall.Dashboard.employee_count} */}
                    {Perecentagedata.whats_app_amount}
                  </div>
                </div>
                <div class="Dash-info">
                  <h6 class="text-muted">WhatsApp </h6>
                  <div class="progress progress-sm">
                    <div
                      class="progress-bar bg-primary"
                      role="progressbar"
                      style={{
                        width: `${Perecentagedata.whats_app_amount / 10}%`,
                      }}
                      aria-valuenow={Perecentagedata.whats_app_amount}
                      aria-valuemin="0"
                      aria-valuemax="100%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* -------------------------------------- */}
          <div className="col-xl-4 col-sm-6 col-12">
            <div className="card">
              <div
                className="card-Body"
                style={{ padding: "8px" }}
                onClick={(e) => {
                  dispatch(getSideBarfilesActions("Bank Details"))

                  navigate("/bankvalidate");
                }}
              >
                <div className="Dash">
                  {/* <div className="DashICON DeclineEmp">
                    <i class="fa-solid fa-user-large-slash"></i>
                  </div> */}
                  <div
                    className=" iconsEmp"
                    style={{ width: "68px", height: "70px" }}
                  >
                    <img src={bank} style={{ width: "100%", height: "100%" }} />
                  </div>

                  <div className="Counts" style={{ fontSize: "30px" }}>
                    {Perecentagedata.bank_count}
                  </div>
                </div>
                <div class="Dash-info">
                  <h6 class="text-muted">Bank</h6>

                  <div class="progress progress-sm">
                    <div
                      class="progress-bar Box4"
                      role="progressbar"
                      style={{
                        width: `${Perecentagedata.bank_count / 10}%`,
                      }}
                      aria-valuenow={Perecentagedata.bank_count}
                      aria-valuemin="0"
                      aria-valuemax="100%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* -------------------------------------- */}
          <div className="col-xl-4 col-sm-6 col-12">
            <div className="card">
              <div
                className="card-Body"
                style={{ padding: "8px" }}
                onClick={(e) => {
                  dispatch(getSideBarfilesActions("Pan Card Details"))

                  navigate("/panvalidate");
                }}
              >
                <div className="Dash">
                  <div
                    className=" iconsEmp"
                    style={{ width: "68px", height: "70px" }}
                  >
                    <img
                      src={pancard}
                      style={{ width: "100%", height: "100%" }}
                    />
                  </div>
                  <div className="Counts" style={{ fontSize: "30px" }}>
                    {Perecentagedata.pan_count}
                  </div>
                </div>
                <div class="Dash-info">
                  <h6 class="text-muted">Pan</h6>

                  <div class="progress progress-sm">
                    <div
                      class="progress-bar Box4 "
                      role="progressbar"
                      style={{
                        width: `${Perecentagedata.pan_count / 10}%`,
                      }}
                      aria-valuenow={Perecentagedata.pan_count}
                      aria-valuemin="0"
                      aria-valuemax="100%"
                    ></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            padding: " 0px 40px",
            marginTop: "-13px",
            marginBottom: "20px",
          }}
        >
          {/* <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              position: "relative",
              top: "95px",
              // width: "92%",
              width: "100%",

              justifyContent: "space-around",
              alignItems: "center",
            }}
          >
            <div
              class=" col-12"
              style={{
                position: "relative",
                top: "-16px",
                display: "flex",
                justifyContent: "flex-end",
                flexDirection: "column",
                zIndex: "1",
                // width: "290px",
              }}
            >
              <div
                align="center"
                type="button"
                style={{
                  display: "flex",
                  justifyContent: "flex-end",
                }}
                onClick={(e) => {
                  const payload = {
                    return_type: "file",
                    export_type: "all",
                  };
                  dispatch(setThefinanceDataExportActions(payload));
                }}
              >
                <a class="dnbtn"></a>
              </div>
            </div>
          </div> */}

          <ReactTable
            data={state.FinanceGetListedData.FinanceDatas}
            columns={columns}
            totalItems={state.FinanceGetListedData.Total_Count}
            currentPage={currentPage}
            onChange={tochange}
            setCurrentPage={setCurrentPage}
            pagesize={pagesize}
            dtpagesize={pageSize}
            dtpageindex={dtpageindex}
            onPrevious={handlePrevious}
            onNextpage={handleNext}
            GotoEnteredPage={GotoEnteredPage}

            pageindex={pageindex}
            datacount={state.FinanceGetListedData.Total_Count}
            MakeCreate={false}
          />
        </div>
      </div>
    </>
  );
};

export default Finance;
